import { render, staticRenderFns } from "./WebCategoryModalForm.vue?vue&type=template&id=9ba5ba12"
import script from "./WebCategoryModalForm.vue?vue&type=script&lang=js"
export * from "./WebCategoryModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports